import {
  getConfigByCountry,
  getCountryFromUrl,
  getLanguageFromUrl,
  getCountryAndLanguage,
} from '@integration-layer/integrationConfig'

/**
 * Nuxt plugin to configure application settings based on route and country.
 *
 * This plugin:
 * 1. Skips configuration for federated environments
 * 2. Sets application configuration based on the current route
 * 3. Determines and sets current language, country, and language-country combination
 *
 * @type {import('nuxt/app').NuxtPlugin}
 * @name nuxt:route-config
 */
export default defineNuxtPlugin(({ _route }) => {
  // Skip configuration for federated environments
  if (useRuntimeConfig().public.isFederated) return

  /**
   * Retrieve configuration based on the current route's country.
   * @type {Object}
   */
  const config = getConfigByCountry(_route)

  // Set application configuration
  useAppConfig().config = config

  /**
   * Set current language from the route's full path.
   * @type {string}
   */
  useAppConfig().currentLanguage = getLanguageFromUrl(_route.fullPath)

  /**
   * Set current country from the route's full path.
   * @type {string}
   */
  useAppConfig().currentCountry = getCountryFromUrl(_route.fullPath)

  /**
   * Set current language and country combination from the route's full path.
   * @type {string}
   */
  useAppConfig().currentLanguageCountry = getCountryAndLanguage(_route.fullPath)
})
